const Constants = {};

Constants.roles = {
    ROLE_ADMINISTRATOR: "ADMINISTRATOR",
    ROLE_TEACHER: "TEACHER",
    ROLE_SECRETARY: "SECRETARY",
    ROLE_STUDENT: "STUDENT",
    ROLE_SYSTEM: "SYSTEM"
};

Constants.enabledOptions = [
    {
        label: "Activo",
        code: true
    },
    {
        label: "Inactivo",
        code: false
    }
];

Constants.yesOrNotOptions = [
    {
        label: "Si",
        code: true
    },
    {
        label: "No",
        code: false
    }
];

Constants.paymentEnabledOptions = [
    {
        label: "Válido",
        code: true
    },
    {
        label: "Anulado",
        code: false
    }
];

Constants.annulledOptions = [
    {
        label: "No",
        code: false
    },
    {
        label: "Si",
        code: true
    }
];

Constants.documentIssuedOptions = [
    'NO ESPECIFICADO', 'CH', 'LP', 'CB', 'OR', 'PT', 'TJ', 'SC', 'BE', 'PD', 'EXTRANJERO'
];

Constants.periodOptions = [
    { name: '1st', value: 1 },
    { name: '2nd', value: 2 },
    { name: '3rd', value: 3 },
    { name: '4th', value: 4 },
    { name: '5th', value: 5 },
    { name: '6th', value: 6 },
    { name: '7th', value: 7 },
    { name: '8th', value: 8 },
    { name: '9th', value: 9 },
    { name: '10th', value: 10 },
    { name: '11th', value: 11 },
    { name: '12th', value: 12 },
    { name: '13th', value: 13 },
    { name: '14th', value: 14 },
    { name: '15th', value: 15 },
    { name: 'Todas', value: null },
];

Constants.periodOptions2 = [
    { name: '1st', value: 1 },
    { name: '2nd', value: 2 },
    { name: '3rd', value: 3 },
    { name: '4th', value: 4 },
    { name: '5th', value: 5 },
    { name: '6th', value: 6 },
    { name: '7th', value: 7 },
    { name: '8th', value: 8 },
    { name: '9th', value: 9 },
    { name: '10th', value: 10 },
    { name: '11th', value: 11 },
    { name: '12th', value: 12 },
    { name: '13th', value: 13 },
    { name: '14th', value: 14 },
    { name: '15th', value: 15 },
];

Constants.parallelOptions = [
    { name: 'Ninguno', value: 'NONE' },
    { name: 'A', value: 'A' },
    { name: 'B', value: 'B' },
    { name: 'C', value: 'C' },
    { name: 'D', value: 'D' },
    { name: 'E', value: 'E' },
];

Constants.genderOptions = [
    { name: 'FEMENINO', value: 'FEMALE' },
    { name: 'MASCULINO', value: 'MALE' },
    { name: 'NO ESPECIFICADO', value: 'NOT_SPECIFIED' },
];

Constants.initialLanguageLevelOptions = [
    { name: 'A1', value: 'A1' },
    { name: 'A2', value: 'A2' },
    { name: 'B1', value: 'B1' },
    { name: 'B2', value: 'B2' },
    { name: 'C1', value: 'C1' },
    { name: 'C2', value: 'C2' },
    { name: 'NO ESPECIFICADO', value: 'NOT_SPECIFIED' },
];

Constants.academicDegreeOptions = [
    { name: 'PRIMARIA', value: 'ELEMENTARY_SCHOOL' },
    { name: 'SECUNDARIA', value: 'HIGH_SCHOOL' },
    { name: 'UNIVERSITARIO', value: 'COLLEGE_STUDENT' },
    { name: 'TÉCNICO', value: 'TECHNICAL' },
    { name: 'PROFESIONAL', value: 'PROFESSIONAL' },
    { name: 'POSTGRADO', value: 'POSTGRADUATE' },
    { name: 'NO ESPECIFICADO', value: 'NOT_SPECIFIED' },
];

Constants.typeOfCourseOptions = [
    { name: 'Regular', value: 'REGULAR' },
    { name: 'Semi-intensivo', value: 'SEMI_INTENSIVE' },
    { name: 'Intensivo', value: 'INTENSIVE' },
    { name: 'Profesional', value: 'PROFESSIONAL' },
    { name: 'Especial', value: 'SPECIAL' },
];

Constants.paymentMethodsOptions = [
    { name: 'Ninguno', value: 1 },
    { name: 'Efectivo', value: 2 },
    { name: 'Tarjeta de débito/crédito', value: 3 },
    { name: 'Cheque', value: 4 },
    { name: 'Transferencia/Depósito', value: 5 },
    { name: 'Adelanto', value: 6 },
    { name: 'Reembolso', value: 7 },
];

export default Constants;